module.exports = "<nav>\n  <div\n    *ngFor=\"let tab of tabs | keys\"\n    [ngClass]=\"{active: tab == current}\"\n    (click)=\"update(tab)\"\n  >\n    {{ tabs[tab] }}\n  </div>\n</nav>\n\n<div class=\"container\" #container>\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/tabs/tabs.component.html
// module id = ../../../../../src/app/ui-shared/tabs/tabs.component.html
// module chunks = main